import { styled, css } from 'styled-components';
import { GridProps, fillRules } from '.';

interface TransientProps {
  $fillRule?: (typeof fillRules)[number];
}

export const Container = styled.div<TransientProps & Omit<GridProps, 'fillRule'>>`
  ${({
    theme: { spacings },
    $fillRule = 'auto-fill',
    horizontalGap = 's0',
    margin = ['s0', 's0', 's0', 's0'],
    minGridSize = '9rem',
    padding = ['s0', 's0', 's0', 's0'],
    verticalGap = 's0',
    numberOfColumns,
    numberOfRows,
  }) => css`
    display: grid;
    gap: ${spacings[verticalGap as keyof typeof spacings]} ${spacings[horizontalGap as keyof typeof spacings]};
    grid-template-columns: repeat(${$fillRule}, minmax(${minGridSize}, 1fr));
    margin: ${spacings[margin[0] as keyof typeof spacings]} ${spacings[margin[1] as keyof typeof spacings]}
      ${spacings[margin[2] as keyof typeof spacings]} ${spacings[margin[3] as keyof typeof spacings]};
    padding: ${spacings[padding[0] as keyof typeof spacings]} ${spacings[padding[1] as keyof typeof spacings]}
      ${spacings[padding[2] as keyof typeof spacings]} ${spacings[padding[3] as keyof typeof spacings]};
    ${
      numberOfColumns &&
      css`
        grid-template-columns: repeat(${numberOfColumns}, 1fr);
      `
    }
    ${
      numberOfRows &&
      css`
        grid-template-rows: repeat(${numberOfRows}, 1fr);
      `
    }
  `}
`;
